import * as React from 'react';
import Head from 'next/head';

import { SITE_TITLE } from '@src/config/constants';
import { HaldiStickyNote } from '@src/routes/common/components/HaldiStickyNote';
import { ReferHowItWorks } from '@src/routes/refer/components/ReferHowItWorks';
import { ReferIntroduction } from '@src/routes/refer/components/ReferIntroduction';

import styles from './refer-a-friend.module.css';

export interface ReferAFriendProps {}

/**
 * @name ReferAFriend
 * @description This page is used for referrals
 */
export const ReferAFriend = (_props: ReferAFriendProps) => {
  return (
    <>
      <Head>
        <title>{`Refer a Friend | ${SITE_TITLE}`}</title>
      </Head>

      <main className={styles.component}>
        <ReferIntroduction />
        <ReferHowItWorks className="ui-border-top" />
        <div className="ui-container-xl">
          <div className=" relative">
            <HaldiStickyNote className={styles.sticky}>
              <div className="text-20 lg:p-1x lg:text-32">
                Thanks for
                <br />
                spreading the word
              </div>
            </HaldiStickyNote>
          </div>
        </div>
      </main>
    </>
  );
};

export default ReferAFriend;
